import { Permission } from "types";
import { useAuthorization } from "../../hooks/useAuthorization";

interface IsGrantedProps {
    permissions: Permission | Permission[];
    isAny?: boolean;
    children: any;
}

export const IsGranted = ({ permissions: permission, isAny = false, children }: IsGrantedProps) => {
    const { isGranted, isGrantedAny } = useAuthorization();
    const permissions = Array.isArray(permission) ? permission : [permission];
    const result = isAny ? isGrantedAny(...permissions) : isGranted(...permissions);
    return result ? children : null;
};
